import bgHeroImg1 from "../assets/borobudur-temple.jpg";
import bgHeroImg2 from "../assets/mount-bromo.jpg";
import bgHeroImg3 from "../assets/derawan-island.jpg";
import bgHeroImg4 from "../assets/nusa-penida.jpg";
import bgHeroImg5 from "../assets/labuan-bajo.jpg";

import aboutUsImg1 from "../assets/about-us-img-1.jpg";
import aboutUsImg2 from "../assets/about-us-img-2.jpg";

import eventsBorobudur from "../assets/events-borobudur.jpg";
import eventsBorobudurImg1 from "../assets/events-borobudur-img-1.jpg";
import eventsBorobudurImg2 from "../assets/events-borobudur-img-2.jpg";

import eventsBromo from "../assets/events-bromo.jpg";
import eventsBromoImg1 from "../assets/events-bromo-img-1.jpg";
import eventsBromoImg2 from "../assets/events-bromo-img-2.jpg";

import eventsLabuanBajo from "../assets/events-labuan-bajo.jpg";
import eventsLabuanBajoImg1 from "../assets/events-labuan-bajo-img-1.jpg";
import eventsLabuanBajoImg2 from "../assets/events-labuan-bajo-img-2.jpg";

import eventsUluwatu from "../assets/events-uluwatu.jpg";
import eventsUluwatuImg1 from "../assets/events-uluwatu-img-1.jpg";
import eventsUluwatuImg2 from "../assets/events-uluwatu-img-2.jpg";

import videoPoster from "../assets/video-poster.png";
import momentsImg1 from "../assets/moments-img-1.jpg";
import momentsImg2 from "../assets/moments-img-2.jpg";
import momentsVideoImg from "../assets/video-img.jpg";

import faqImg from "../assets/faq-img.jpg";

import blogBromo from "../assets/blog-bromo.jpg";
import blogBromoImg1 from "../assets/blog-bromo-img-1.jpg";
import blogBromoImg2 from "../assets/blog-bromo-img-2.jpg";
import blogKomodo from "../assets/blog-komodo.jpg";
import blogKomodoImg1 from "../assets/blog-komodo-img-1.jpg";
import blogKomodoImg2 from "../assets/blog-komodo-img-2.jpg";

import bgWorldMap from "../assets/bg-world-map.png";


export default {
    bgHeroImg1,
    bgHeroImg2,
    bgHeroImg3,
    bgHeroImg4,
    bgHeroImg5,

    aboutUsImg1,
    aboutUsImg2,

    eventsBorobudur,
    eventsBorobudurImg1,
    eventsBorobudurImg2,

    eventsBromo,
    eventsBromoImg1,
    eventsBromoImg2,

    eventsLabuanBajo,
    eventsLabuanBajoImg1,
    eventsLabuanBajoImg2,
    
    eventsUluwatu,
    eventsUluwatuImg1,
    eventsUluwatuImg2,

    videoPoster,
    momentsImg1,
    momentsImg2,
    momentsVideoImg,
    
    faqImg,

    blogBromo,
    blogBromoImg1,
    blogBromoImg2,
    blogKomodo,
    blogKomodoImg1,
    blogKomodoImg2,

    bgWorldMap
}